import { useInViewport } from 'ahooks';
import { Spin } from 'antd';
import SafeImage from 'components/SafeImage';
import { isNil } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';
import { useChatContext } from 'views/Conversation/Chat/contexts/ChatContext';

interface AttachmentImageProps {
  data: Conversation.MsgAttachmentInfo;
  getURL: () => Promise<{ url: string }>;
}

const AttachmentImageContent = (props: AttachmentImageProps) => {
  const {
    data: { url },
    getURL,
  } = props;
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState(url);

  useEffect(() => {
    if (!url) {
      setLoading(true);
      getURL()
        .then(({ url }) => {
          setSource(url);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [url, getURL]);

  if (loading) {
    return <Spin spinning />;
  }

  return (
    <SafeImage preview src={source} width={56} height={56} imgSize={{ width: 56, height: 56 }} />
  );
};

export const AttachmentImage = (props: AttachmentImageProps) => {
  const { dialogRef } = useChatContext();
  const target = dialogRef?.dom;

  const ref = useRef<HTMLDivElement>(null);
  const [inViewPort] = useInViewport(ref);
  const [load, setLoad] = useState(isNil(target));

  useEffect(() => {
    if (inViewPort && !load) {
      setLoad(true);
    }
  }, [inViewPort, load]);

  return (
    <div ref={ref} className="relative w-[56px] h-[56px] flex items-center justify-center">
      {load && <AttachmentImageContent {...props} />}
    </div>
  );
};
